// let apiUrl =  (path) => `https://www.kitchendesign.ae/apis/wp-json/wp/v2/${path}`
let apiUrl =  (path) => `https://www.kitchendesign.ae/apis/wp-json/wp/v2/${path}`
// let apiUrl =  (path) => `http://localhost:5001/wp-json/wp/v2/${path}`
// let footerApiUrl =  (path) => `http://localhost:5001/wp-json/wp/v2/${path}`
// let footerApiUrl =  (path) => `https://www.beuniquegroup.dev/snaidero/wp-json/wp/v2/${path}`

export default apiUrl;